



















































import { Prop } from 'vue-property-decorator'
import { Component, mixins } from '@niknevis/vue-modules'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import TabularHeader from '@/modules/shared/components/shared/TabularHeader.vue'
import PanelContentItemShowTabular from '@/modules/content-item/components/panel/PanelContentItemShowTabular.vue'
import BaseButtonDropdown from '@/modules/shared/components/shared/kit/BaseButtonDropdown.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import Heading from '@/modules/common/layout/components/shared/Heading.vue'
import { ContentItemContentResourceType } from '@/modules/content-item/models/content-item-resource.model'
import { PanelContentItemRoute } from '@/modules/content-item/routes/panel-content-item.route'
import ContentDownloadDropDown from '@/modules/shared/components/shared/ContentDownloadDropDown.vue'
import { ContentFormat } from '@/modules/content/models/content-resource.model'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'
import TinyMceEditor from '@/modules/common/editor/components/shared/TinyMceEditor.vue'

@Component({
  components: {
    TinyMceEditor,
    ContentDownloadDropDown,
    Heading,
    BaseButton,
    BaseButtonDropdown,
    PanelContentItemShowTabular,
    TabularHeader,
    Modal
  }
})
export default class PanelContentItemShowContentModal extends mixins(DialogMixin) {
  constructor(
    private readonly contentItemRoutes: PanelContentItemRoute
  ) {
    super()
  }

  @Prop() contentItem!: ContentItemContentResourceType
  @Prop() label!: string

  modalVisibility: boolean = true

  private contentFormat = ContentFormat

  get isDisableAssignButton() {
    return this.contentItem.data.assignable === false
  }

}
